export const disableActionsByDefaultModal = (columnId: string) => {
  return (
    columnId === 'categiria-compacta-nome-id' ||
    columnId === 'produto-codigo-id' ||
    columnId === 'produto-nome-id' ||
    columnId === 'recebimentos-pedidos-id' ||
    columnId === 'recebimentos-quantidade-id'
  )
}
